export default "__VITE_ASSET__HdynFDI3__"